export const prizes = [
  {
    text: 'Пицца 30см',
    count: '10',
    type: 'circle',
  },
  {
    text: 'сертификат 1000',
    count: '10',
    type: 'certificate',
  },
  {
    text: 'Пицца 40см',
    count: '2',
    type: 'circle',
  },
  {
    text: '20%',
    count: '13',
    type: 'percent',
  },
  {
    text: 'сертификат 500',
    count: '15',
    type: 'certificate',
  },
  {
    text: '30%',
    count: '14',
    type: 'percent',
  },
  {
    text: '15%',
    count: '10',
    type: 'percent',
  },
  {
    text: 'Пицца 23см',
    count: '15',
    type: 'circle',
  },
];
